import { useState } from "react";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import { Divider } from "@mui/material";
import Slicks from "./Slicks";
import Swipe from "./Swipe";

// Import Swiper styles
import "swiper/css";

export default function LibraryPc() {
  const [activeTab, setActiveTab] = useState(0);
  const [currentTab, setCurrentTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState("tab1");
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    if (selectedTab === "tab1") setSelectedTab("tab2");
    else if (selectedTab === "tab2") setSelectedTab("tab3");
  };

  const handlePrev = () => {
    if (selectedTab === "tab3") setSelectedTab("tab2");
    else if (selectedTab === "tab2") setSelectedTab("tab1");
  };
  return (
    <div className="container mx-auto p-3 w-full">
      <div className="grid grid-cols-2 lg:grid-cols-9 mt-10 cursor-pointer w-full  rounded-lg bg-[#FAFAFA] lg:h-[4.875rem] items-center lg:flex ">
        <button
          className={`py-2 px-4 text-sm font-medium cursor-pointer rounded-[24px] ${
            activeTab === 0
              ? "bg-[#27C6FF] text-white"
              : "bg-transparent text-black"
          }`}
          onClick={() => setActiveTab(0)}
        >
          2024
        </button>
        <button
          className={`py-2 px-4 text-sm font-medium cursor-pointer rounded-[24px] ${
            activeTab === 1
              ? "bg-[#27C6FF] text-white"
              : "bg-transparent text-black"
          }`}
          onClick={() => setActiveTab(1)}
        >
          2023
        </button>
        <button
          className={`py-2 px-4 text-sm font-medium cursor-pointer rounded-[24px] ${
            activeTab === 2
              ? "bg-[#27C6FF] text-white"
              : "bg-transparent text-black"
          }`}
          onClick={() => setActiveTab(2)}
        >
          2022
        </button>
        <button
          className={`py-2 px-4 text-sm font-medium cursor-pointer rounded-[24px] ${
            activeTab === 3
              ? "bg-[#27C6FF] text-white"
              : "bg-transparent text-black"
          }`}
          onClick={() => setActiveTab(3)}
        >
          2021
        </button>
        <button
          className={`py-2 px-4 text-sm font-medium cursor-pointer rounded-[24px] ${
            activeTab === 4
              ? "bg-[#27C6FF] text-white"
              : "bg-transparent text-black"
          }`}
          onClick={() => setActiveTab(4)}
        >
          2020
        </button>
      </div>
      <div className="mt-4">
        <Divider />
        <div className="w-full flex items-center justify-between mt-2">
          {/* Left Arrow */}
          <button onClick={handlePrev} className="p-2">
            <MdArrowBackIosNew size={20} />
          </button>

          {/* Tabs */}
          <div className="flex-1 flex items-center justify-around text-center text-lg font-semibold">
            <div
              onClick={() => setSelectedTab("tab1")}
              className={`cursor-pointer ${
                selectedTab === "tab1" ? "text-blue-600" : "text-gray-400"
              }`}
            >
              Chào mừng ngày lễ Phụ nữ Việt Nam 20/10 <br />
              <span className="text-sm font-normal text-gray-500">10/2024</span>
            </div>
            <span className="text-gray-300">|</span>
            <div
              onClick={() => setSelectedTab("tab2")}
              className={`cursor-pointer ${
                selectedTab === "tab2" ? "text-blue-600" : "text-gray-400"
              }`}
            >
              Teambuilding 2024 <br />
              <span className="text-sm font-normal text-gray-500">12/2024</span>
            </div>
            <span className="text-gray-300">|</span>
            <div
              onClick={() => setSelectedTab("tab3")}
              className={`cursor-pointer ${
                selectedTab === "tab3" ? "text-blue-600" : "text-gray-400"
              }`}
            >
              Year End Party <br />
              <span className="text-sm font-normal text-gray-500">12/2024</span>
            </div>
          </div>

          {/* Right Arrow */}
          <button onClick={handleNext} className="p-2">
            <MdArrowForwardIos size={20} />
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="mt-4 p-4 border-t">
        {selectedTab === "tab1" && (
          <div className="w-full">
            <Slicks />
            <div className="mt-6">
              <Swipe />
            </div>
          </div>
        )}
        {selectedTab === "tab2" && (
          <div>
            <h2 className="text-xl font-semibold">Teambuilding 2024</h2>
            Loading...
          </div>
        )}
        {selectedTab === "tab3" && (
          <div>
            <h2 className="text-xl font-semibold">Year End Party</h2>
            Loading...
          </div>
        )}
      </div>
    </div>
  );
}
